import React from 'react';
import { Nullable } from 'global';
import moment, { Moment } from 'moment';
import { useForm } from 'react-hook-form';
import { DateField } from 'components/form';

import { useVO } from '../hooks';

interface FormValues {
  date: Moment | '';
}

interface EstimatedCloseDatePickerProps {
  voId: string;
  estimatedCloseDate?: string | null;
}

export const EstimatedCloseDatePicker = ({ voId, estimatedCloseDate }: EstimatedCloseDatePickerProps) => {
  const { updateEstimatedCloseDate, isVOEstimatedCloseDateUpdating } = useVO();

  const { control } = useForm<FormValues>({
    defaultValues: {
      date: estimatedCloseDate ? moment(estimatedCloseDate) : '',
    },
  });

  const handleChange = async (value: Nullable<Moment>) => {
    if (!value || !moment.isMoment(value) || !value.isValid()) return;

    const year = value.year();
    if (year < 1900 || year > 2100) return;

    if (estimatedCloseDate && value.isSame(moment(estimatedCloseDate), 'day')) return;

    await updateEstimatedCloseDate({
      voId,
      estimatedCloseDate: value.toISOString(),
    });
  };

  const handleClear = async () => {
    await updateEstimatedCloseDate({
      voId,
      estimatedCloseDate: '',
    });
  };

  return (
    <DateField
      name="date"
      control={control}
      label="Expected Close"
      extraAction={handleChange}
      disabled={isVOEstimatedCloseDateUpdating}
      slotProps={{
        textField: {
          size: 'small',
          variant: 'outlined',
        },
        field: {
          clearable: true,
          onClear: handleClear,
        },
      }}
    />
  );
};
